module.exports = __webpack_public_path__ + "static/media/tree-hex.91f4e13b.png";